module.exports = __webpack_public_path__ + "img/mainbg.3ba69078.png";